








































































import { Component, Inject, Vue } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import {
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_ERRORS,
  CHANGE_PASSWORD_LOADING,
  PERFORM_CHANGE_PASSWORD,
  SET_CHANGE_PASSWORD_ERRORS,
  SET_CHANGE_PASSWORD_LOADING,
  SET_PERFORM_CHANGE_PASSWORD,
} from '@/types/lobby.types';
import { USER_DETAILS } from '@/types/authentication.types';
import { UserDetails } from '@/models/UserDetails.model';
import { ChangePasswordRequest } from '@/models/request/ChangePasswordRequest';

interface DataCleansingModel {
  email: string;
  phone: string;
}

@Component({})
export default class PerformChangePasswordModal extends Vue {

  @Inject() public $validator;

  @Action(CHANGE_PASSWORD, StoreNamespace.LOBBY) public changePassword;

  @Mutation(SET_CHANGE_PASSWORD_ERRORS, StoreNamespace.LOBBY) public setChangePasswordErrors;
  @Mutation(SET_PERFORM_CHANGE_PASSWORD, StoreNamespace.LOBBY) public setPerformChangePassword;
  @Mutation(SET_CHANGE_PASSWORD_LOADING, StoreNamespace.LOBBY) public setChangePasswordLoading;

  @Getter(USER_DETAILS, StoreNamespace.AUTHENTICATION) public userDetails!: UserDetails;
  @Getter(CHANGE_PASSWORD_ERRORS, StoreNamespace.LOBBY) public changePasswordErrors!: string[];
  @Getter(CHANGE_PASSWORD_LOADING, StoreNamespace.LOBBY) public changePasswordLoading!: boolean;
  @Getter(PERFORM_CHANGE_PASSWORD, StoreNamespace.LOBBY) public performChangePassword!: boolean;

  private auth: ChangePasswordRequest = {} as ChangePasswordRequest;
  private newPasswordRepeat: string = '';

  public mounted() {
    this.setChangePasswordErrors([]);
    this.setChangePasswordLoading(false);
    this.setPerformChangePassword(false);
  }

  public onSubmit() {
    this.setChangePasswordLoading(true);
    this.setChangePasswordErrors([]);
    if (this.auth.newPassword === this.newPasswordRepeat) {
      this.changePassword({
        requestBody: this.auth,
      });
    } else {
      this.setChangePasswordErrors(['' + this.$t('password_errors.not_match')]);
      this.setChangePasswordLoading(false);
    }
  }

  public closeDialog(): void {
    this.setPerformChangePassword(false);
    this.$emit('onCancel');
  }

  public destroyed() {
    this.setPerformChangePassword(false);
  }

}
